export interface IClientSwitchErrorNotice {
  type: 'error' | 'warning'
  title: string
  message: string
}

const SWITCH_FAILED: IClientSwitchErrorNotice = {
  type: 'error',
  title: 'Switch failed',
  message: 'We could not switch you to that client. Please try again.',
}

const RETURN_FAILED: IClientSwitchErrorNotice = {
  type: 'error',
  title: 'Return failed',
  message: 'We could not switch you back to your account. Please try again.',
}

export const CLIENT_NOT_PROVISIONED_NOTICE: IClientSwitchErrorNotice = {
  type: 'warning',
  title: 'No account yet',
  message: 'This client does not have a provisioned account to switch into.',
}

export const CLIENT_ACCOUNT_CLOSED_NOTICE: IClientSwitchErrorNotice = {
  type: 'warning',
  title: 'Account closed',
  message: 'This client account is closed and cannot be accessed.',
}

const SWITCH_NOTICES: Record<string, IClientSwitchErrorNotice> = {
  'customer/switch-client-not_provisioned': CLIENT_NOT_PROVISIONED_NOTICE,
  'customer/switch-client-account_closed': CLIENT_ACCOUNT_CLOSED_NOTICE,
  'customer/switch-client-relationship_ended': {
    type: 'warning',
    title: 'Client relationship ended',
    message: 'Your relationship with this client has ended, so you can no longer switch into their account.',
  },
  'customer/switch-client-not_a_child': {
    type: 'error',
    title: 'Switch not allowed',
    message: 'This client is not managed by your account.',
  },
  'customer/switch-client-chained': {
    type: 'warning',
    title: 'Switch not allowed',
    message: 'Return to your own account before switching to another client.',
  },
  'customer/switch-client-identity': {
    type: 'error',
    title: 'Switch failed',
    message: 'We could not confirm your sign-in. Please sign out and sign in again.',
  },
}

const RETURN_NOTICES: Record<string, IClientSwitchErrorNotice> = {
  'customer/switch-client-not_switched': {
    type: 'warning',
    title: 'Not viewing a client',
    message: 'This session is no longer viewing a client. Refresh the page to continue.',
  },
}

function errorType(err: unknown): string | undefined {
  const type = (err as any)?.errorData?.type ?? (err as any)?.response?.data?.type
  return typeof type === 'string' ? type : undefined
}

function errorStatus(err: unknown): number | undefined {
  const e = err as any
  return e?.response?.status ?? e?.status ?? e?.errorData?.statusCode
}

export function switchErrorNotice(err?: unknown): IClientSwitchErrorNotice {
  const notice = SWITCH_NOTICES[errorType(err) ?? '']
  if (notice) return notice
  if (errorStatus(err) === 403) {
    return { type: 'error', title: 'Switch not allowed', message: 'You do not have permission to switch to this client.' }
  }
  return SWITCH_FAILED
}

export function returnErrorNotice(err?: unknown): IClientSwitchErrorNotice {
  return RETURN_NOTICES[errorType(err) ?? ''] ?? RETURN_FAILED
}
